module.exports = require("./nnh.d.ts");